import { useQuery } from "@tanstack/react-query";

import { CACHE_DURATIONS } from "src/utils/constants";

import axios from 'src/lib/axios';

import type { BucketDetailResponse } from "../../../types/s3";

const getBucketDetailsById = async (
  bucketId: string,
  params?: { page?: number; page_size?: number; prefix?: string | null }
) => {
  const response = await axios.get(`/api/storage/list?bucket=${bucketId}`, { params });
  return response.data;
};

export const useGetBucketById = (
  bucketId: string,
  params?: { page?: number; page_size?: number; prefix?: string | null }
) => {
  const { data, isLoading, refetch, error } = useQuery<BucketDetailResponse>({
    queryKey: ['bucket', bucketId, params],
    queryFn: () => getBucketDetailsById(bucketId, params),
    enabled: !!bucketId,
    retry: 1,
    staleTime: CACHE_DURATIONS.SHORT
  });

  return {
    bucketDetails: data,
    isLoadingBucketDetails: isLoading,
    refetchBucketDetails: refetch,
    error,
  };
};
